module.exports = __webpack_public_path__ + "img/Dantam Fashion 14.77252908.jpg";